import React from 'react';

const CheckIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries" data-testid="check-icon">
      <div className="vbz-icon-beneficiaries-check" />
    </div>
  );
};

export default CheckIcon;
